import React from 'react';
import { xor } from 'ramda';

/*
props: { isActive, refs: { layerRef, layoutRef } }
props + popup: { id, component, render, layerId, isModal, position, data, content }
 */
export const ManagedPopupFactory = ({ isActive, component, render, ...props }) => {
    if (!xor(component, render)) {
        throw new Error('Invalid Managed Popup Factory arguments. Provide either "component" or "render", not both.');
    }

    if (!isActive) {
        return null;
    }

    if (component) {
        return React.createElement(component, props);
    }

    return render(props);
};
